/**
 * Vista del listado de solicitudes según los roles · espejo exacto de
 * `soloPropias` en `ListarMisSolicitudesHandler` (backend): el Solicitante
 * "puro" ve solo las suyas; Auditor, Administrador y Mesa de Control ven todas.
 */
export function esVistaSoloPropias(roles: ReadonlyArray<string>): boolean {
  const ven = (r: string) => roles.includes(r);
  return ven("Solicitante") && !ven("Auditor") && !ven("Administrador") && !ven("MesaDeControl");
}

export interface EncabezadoSolicitudes {
  titulo: string;
  descripcion: string;
}

/**
 * Título y subtítulo de la página · ÚNICA fuente para `MisSolicitudesPage` y su
 * skeleton (la transición ruta → página no cambia el texto del encabezado).
 */
export function encabezadoSolicitudes(soloPropias: boolean): EncabezadoSolicitudes {
  return soloPropias
    ? {
        titulo: "Mis solicitudes de pago",
        descripcion:
          "Da seguimiento a tus solicitudes de pago a proveedores · consulta su estado, documentos y el siguiente paso de cada una.",
      }
    : {
        titulo: "Solicitudes de pago",
        descripcion:
          "Todas las solicitudes de pago del sistema · consulta su estado y, si es necesario, da de baja cualquiera de ellas.",
      };
}
